(() => {
  if (customElements.get('cart-finish-selector')) return;
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body) } : {cache:'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error(data.description || data.message || 'Unable to update colours. Please try again.');
    return data;
  };
  let updating = false;
  customElements.define('cart-finish-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-finish-data]').textContent);
      this.drawer = this.closest('cart-drawer');
      this.dialog = this.querySelector('dialog');
      this.select = this.querySelector('[data-finish-select]');
      this.status();
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target === this.select) this.apply(new Map([[Number(this.select.value),1]]));
      });
      this.addEventListener('click', event => {if(event.target.closest('[data-finish-open]')) this.open();});
      this.dialog.addEventListener('click', event => {
        if(event.target.closest('[data-finish-close]') && !this.busy) this.dialog.close();
        const button=event.target.closest('[data-finish-step]');
        if(button) {
          const id=Number(button.dataset.variant);
          this.setCount(id,this.count(id)+Number(button.dataset.finishStep));
        }
      });
      this.dialog.addEventListener('change', event => {
        event.stopPropagation();
        if(event.target.matches('[data-finish-count]')) this.setCount(Number(event.target.dataset.finishCount),Number(event.target.value));
      });
      this.dialog.addEventListener('cancel', event => {if(this.busy) event.preventDefault();});
      this.dialog.addEventListener('close', () => {
        if(this.isConnected) this.append(this.dialog);
        else this.dialog.remove();
      });
    }
    stock(variant, quantity=1) {
      if (!variant.available) return 'Sold out';
      if (variant.label) return `Backorder · ${variant.label}`;
      if (variant.managed && variant.continue && variant.stock < quantity) return 'Backorder · dispatch date to be confirmed';
      return 'In stock';
    }
    status() {
      const variant = this.data.variants.find(v=>v.id === this.data.variant);
      const label = this.querySelector('[data-finish-stock]');
      label.textContent = this.stock(variant, this.data.quantity);
      label.dataset.state = label.textContent === 'In stock' ? 'stock' : 'backorder';
      label.hidden = label.textContent === 'In stock';
    }
    async freshData() {
      const drawer=this.drawer || this.closest('cart-drawer');
      const response=await fetch(root+'?section_id='+encodeURIComponent(drawer.dataset.sectionId), {cache:'no-store'});
      if(!response.ok) throw new Error('Could not check current stock. Please try again.');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const options=[...doc.querySelectorAll('cart-finish-selector')].map(node=>JSON.parse(node.querySelector('[data-finish-data]').textContent));
      const data=options.find(data=>data.key===this.data.key)||options.find(data=>data.product===this.data.product);
      if(!data) throw new Error('This product is no longer in your cart.');
      return data;
    }
    count(id) {return this.data.lines.filter(line=>line.variant===id).reduce((sum,line)=>sum+line.quantity,0);}
    async open() {
      if(this.busy || updating) return;
      this.setBusy(true);
      try {
        this.data=await this.freshData();
        this.order=[...new Set([...this.data.lines.map(line=>line.variant),...this.data.variants.map(v=>v.id)])];
        this.renderRows();
        this.dialog.querySelector('[data-finish-dialog-error]').hidden=true;
        // Keep the popup open while the cart contents beneath it are refreshed.
        this.drawer.append(this.dialog);
        this.dialog.showModal();
        this.dialog.querySelector('[data-finish-heading]').focus({preventScroll:true});
      } catch(error) { this.error(error.message); }
      finally { this.setBusy(false); }
    }
    renderRows() {
      const rows=this.dialog.querySelector('[data-finish-rows]');rows.replaceChildren();
      this.order.forEach(id=>{
        const v=this.data.variants.find(v=>v.id===id);if(!v)return;
        const row=document.createElement('div');row.className='cart-finish__row cart-finish__live-row';
        const swatch=document.createElement('img');swatch.className='cart-finish__grain';swatch.src=v.swatch;swatch.alt='';swatch.width=40;swatch.height=40;
        const copy=document.createElement('span');copy.className='cart-finish__row-copy';
        const title=document.createElement('strong');title.textContent=v.title;
        const detail=document.createElement('small');detail.textContent=`${this.stock(v,Math.max(1,this.count(id)))} · ${v.price} each`;
        copy.append(title,detail);
        const controls=document.createElement('div');controls.className='cart-finish__stepper';
        const makeButton=(step,label)=>{const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset.finishStep=step;button.dataset.variant=id;button.setAttribute('aria-label',`${step>0?'Add':'Remove'} one ${v.title}`);button.disabled=step<0?this.count(id)===0:!v.available;return button;};
        const input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.value=String(this.count(id));input.dataset.finishCount=id;input.setAttribute('aria-label',`${v.title} quantity`);input.inputMode='numeric';
        controls.append(makeButton(-1,'−'),input,makeButton(1,'+'));
        row.append(swatch,copy,controls);rows.append(row);
      });
      const total=this.data.lines.reduce((sum,line)=>sum+line.quantity,0);
      this.dialog.querySelector('[data-finish-total]').textContent=`${total} ${total===1?'unit':'units'} in your cart`;
    }
    setBusy(busy) {
      this.busy=busy;this.setAttribute('aria-busy',String(busy));
      this.querySelector('.cart-finish__busy').hidden=!busy;
      this.querySelector('.cart-finish__chevron').hidden=busy;
      if(this.select) this.select.disabled=busy;
      this.querySelector('[data-finish-open]')?.toggleAttribute('disabled',busy);
      this.dialog.querySelector('[data-finish-close]').disabled=busy;
      this.dialog.querySelectorAll('[data-finish-count]').forEach(input=>{input.disabled=busy;});
      this.dialog.querySelectorAll('[data-finish-step]').forEach(button=>{
        const id=Number(button.dataset.variant), v=this.data.variants.find(v=>v.id===id);
        button.disabled=busy || (Number(button.dataset.finishStep)<0?this.count(id)===0:!v.available);
      });
      this.dialog.querySelector('[data-finish-popup-status]').classList.toggle('is-saving',busy);
    }
    error(message) {
      const node=this.dialog.open?this.dialog.querySelector('[data-finish-dialog-error]'):this.querySelector('[data-finish-error]');node.textContent=message;node.hidden=false;
    }
    async setCount(id,quantity) {
      if(this.busy || updating || !Number.isInteger(quantity) || quantity<0){this.renderRows();return;}
      if(quantity===this.count(id))return;
      updating=true;this.setBusy(true);
      this.dialog.querySelector('[data-finish-dialog-error]').hidden=true;
      try {
        const cart=await request('cart.js');
        const lines=cart.items.filter(item=>item.product_id===this.data.product && item.variant_id===id);
        const current=lines.reduce((sum,item)=>sum+item.quantity,0);
        // Detect edits in another tab instead of overwriting them.
        if(current!==this.count(id)) throw new Error('Your cart changed. The quantities have been refreshed; please try again.');
        if(quantity===0 && current>0){
          const inputs=[...this.drawer.querySelectorAll('input[data-index]')];
          const input=inputs.find(input=>input.dataset.index===lines[0].key);
          if(input){
            const confirmationTarget={dataset:input.dataset,defaultValue:String(current),closest:selector=>input.closest(selector)};
            const remove=await this.drawer.querySelector('cart-items').confirmRemoval(confirmationTarget);
            if(!remove)return;
          }
        }
        const variant=this.data.variants.find(v=>v.id===id);
        if(quantity>current){
          if(!variant?.available) throw new Error('This colour is currently sold out.');
          if(lines.length){
            const line=lines[0];
            await request('cart/change.js',{id:line.key,quantity:line.quantity+quantity-current});
          }else{
            const properties={};if(variant.dispatch)properties['Estimated dispatch']=variant.dispatch;
            await request('cart/add.js',{items:[{id,quantity,properties}]});
          }
        }else{
          let reduce=current-quantity;const updates={};
          // Keep covered units when only part of a colour's quantity is removed.
          const covered=new Set(cart.items.map(item=>item.properties?.['_Covered line']).filter(Boolean));
          const ordered=[...lines].sort((a,b)=>Number(covered.has(a.key))-Number(covered.has(b.key)));
          for(const line of ordered){const remove=Math.min(reduce,line.quantity);if(!remove)continue;updates[line.key]=line.quantity-remove;reduce-=remove;}
          for(const warranty of cart.items){const key=warranty.properties?.['_Covered line'];if(key && key in updates)updates[warranty.key]=updates[key];}
          await request('cart/update.js',{updates});
        }
        // Keep purchased warranty quantities aligned with their covered lines.
        const after=await request('cart.js');const warrantyUpdates={};
        for(const warranty of after.items){const key=warranty.properties?.['_Covered line'];if(!key)continue;const covered=after.items.find(item=>item.key===key);const required=covered?.quantity||0;if(warranty.quantity!==required)warrantyUpdates[warranty.key]=required;}
        if(Object.keys(warrantyUpdates).length)await request('cart/update.js',{updates:warrantyUpdates});
        await this.drawer.onCartRefresh({detail:{open:true,animate:false}});
        const total=after.items.filter(item=>item.product_id===this.data.product).reduce((n,item)=>n+item.quantity,0);
        if(total===0){this.dialog.close();return;}
        this.data=await this.freshData();this.renderRows();
        document.dispatchEvent(new CustomEvent('element:cart-added',{bubbles:true}));
      } catch(error) {
        try {this.data=await this.freshData();this.renderRows();await this.drawer.onCartRefresh({detail:{open:true,animate:false}});}catch(refreshError){}
        this.error(error.message);
      } finally {updating=false;this.setBusy(false);if(this.dialog.open)this.renderRows();}
    }
    async apply(allocation) {
      if(this.busy || updating) return;
      if([...allocation.values()].some(n=>!Number.isInteger(n)||n<0) || [...allocation.values()].reduce((a,b)=>a+b,0)!==this.data.quantity) return;
      if((allocation.get(this.data.variant)||0)===this.data.quantity) {this.dialog.close();return;}
      updating=true;this.setBusy(true);this.querySelectorAll('[role="alert"]').forEach(el=>el.hidden=true);
      const token=crypto.randomUUID();let committed=false,source,originalQuantity;
      try {
        const fresh=await this.freshData();
        if(fresh.quantity!==this.data.quantity) throw new Error('Your cart quantity changed. Reopen the colour selector and try again.');
        this.data=fresh;
        const cart=await request('cart.js');source=cart.items.find(item=>item.key===this.data.key);
        if(!source || source.quantity!==this.data.quantity) throw new Error('Your cart changed. Please reopen the colour selector.');
        originalQuantity=source.quantity;
        const keep=allocation.get(source.variant_id)||0;
        const additions=[];
        for(const [id,quantity] of allocation) {
          if(!quantity || id===source.variant_id) continue;
          const variant=this.data.variants.find(v=>v.id===id);
          if(!variant?.available) throw new Error('That colour is no longer available. Choose another finish.');
          const already=cart.items.filter(item=>item.variant_id===id).reduce((n,item)=>n+item.quantity,0);
          if(variant.managed && !variant.continue && already+quantity>variant.stock) throw new Error(`Only ${Math.max(0,variant.stock-already)} more ${variant.title} units are available.`);
          const properties={...source.properties, '_Finish configuration':token};
          delete properties['Estimated dispatch'];
          if(variant.dispatch) properties['Estimated dispatch']=variant.dispatch;
          const item={id,quantity,properties};
          if(source.selling_plan_allocation) item.selling_plan=source.selling_plan_allocation.selling_plan.id;
          additions.push(item);
        }
        // Reserve replacements first: rejected inventory must not remove existing units.
        await request('cart/add.js',{items:additions});
        let current=await request('cart.js');
        const replacements=current.items.filter(item=>item.properties?.['_Finish configuration']===token);
        for(const addition of additions) {
          if(replacements.find(item=>item.variant_id===addition.id)?.quantity!==addition.quantity) throw new Error('The requested quantity could not be added. Your original colours will be kept.');
        }
        const warranties=cart.items.filter(item=>item.properties?.['_Covered line']===source.key);
        const warrantyAdditions=[];
        for(const warranty of warranties) for(const replacement of replacements) {
          warrantyAdditions.push({id:warranty.variant_id,quantity:replacement.quantity,properties:{...warranty.properties,'_Covered line':replacement.key,'_Finish configuration':token}});
        }
        if(warrantyAdditions.length) await request('cart/add.js',{items:warrantyAdditions});
        current=await request('cart.js');
        if(!current.items.some(item=>item.key===source.key && item.quantity===originalQuantity)) throw new Error('Your cart changed while updating. Please try again.');
        const updates={[source.key]:keep};
        warranties.forEach(item=>{updates[item.key]=keep;});
        await request('cart/update.js',{updates});
        committed=true;
        this.dialog.close();
        await this.closest('cart-drawer').onCartRefresh({detail:{open:true,animate:false}});
        document.dispatchEvent(new CustomEvent('element:cart-added',{bubbles:true}));
      } catch(error) {
        // Roll back only the newly staged lines if the original units are still intact.
        if(!committed) {
          try {
            const current=await request('cart.js');
            const original=current.items.find(item=>item.key===source?.key);
            const expected=allocation.get(source?.variant_id)||0;
            if(source && (original?.quantity||0)===expected) committed=true;
            else {
              const updates={};current.items.filter(item=>item.properties?.['_Finish configuration']===token).forEach(item=>updates[item.key]=0);
              if(Object.keys(updates).length) await request('cart/update.js',{updates});
            }
          } catch(recoveryError) {error=new Error('Could not confirm the update. Reopen your cart and check its quantities before trying again.');}
        }
        if(committed) {this.dialog.close();document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));}
        else {if(this.select) this.select.value=String(this.data.variant);this.error(error.message);}
      } finally { updating=false;this.setBusy(false); }
    }
  });
})();
